import React, { useState, useEffect, useCallback } from "react";
import Layout from "containers/Layout";
// import "react-dropdown/style.css";

import { Headersub } from "../GenericComponent/HeaderSub/headersub";
import { TableThongKe } from "./TableThongKe";
import { TableThongKeMoney88 } from "./TableThongKeMoney88";
import { SearchBarTrangChu, khoangMacDinh } from "./SearchBarTrangChu";
import CanvasJSReact from "../../assets/react-canvasjs-chart/canvasjs.react";
import HomeApi from "service/homeapi";
import UserApi from "service/userApi";
import configs from "constants/configs";
import { formatNumber } from "utils/currencyFormat";
import LayoutV2 from "containers/LayoutV2";
import { formatMoney } from "utils/currencyFormat";
import { format, startOfMonth } from "date-fns";
import { pushNotification } from "utils/notifications";
import ConfigSystemApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigSystemApi";
import cauHinh from "utils/cauHinh";
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export const TrangChu = () => {
  const initData = {
    TongGiaoDichTrongNgay: 0,
    HdTrongNgay: 0,
    TongChovayTrongNgay: 0.0,
    HdTHhuHomNay: 0,
    TienThuHomNay: 0.0,
    HdDuKienThu: 0,
    TienDuKienThu: 0.0,
    QuyTien: 0.0,
    TongHDDangVay: 0,
    TongSoCamDo: 0,
    TongSoTinChap: 0,
    TongSoTraGop: 0,
    TongSoBHTraGop: 0,
    TongTienChoVay: 0.0,
    TongTienCamDo: 0.0,
    TongTienTinChap: 0.0,
    TongTienVayHo: 0.0,
    TongTienBHTraGop: 0.0,
    TongLaiDaThu: 0.0,
    TongCamDoLaiDaThu: 0.0,
    TongTinChapLaiDaThu: 0.0,
    TongLaiHoLaiDaThu: 0.0,
    TongLaiDuKien: 0.0,
    TongLaiBHTraGopDaThu: 0.0,
    TongSoChoDuyet: 0,
    tongCamDoLaiTrongThang: 0,
    tongTinChapLaiTrongThang: 0,
    tongLaiHoLaiTrongThang: 0,
    TongLaiBHTraGopTrongThang: 0,
  };
  const initPhanQuyen = {
    trangchu_thongtintrangchu: true,
    trangchu_thongtinhopdong: true,
    isBanHangTraGop: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);

  const [thongtinHome, setInfo] = useState(initData);
  // null = chưa lọc, vào trang chủ hiển thị toàn bộ như ban đầu; chỉ khi bấm tìm kiếm mới lọc
  const [filters, setFilters] = useState(null);
  const [loading, setLoading] = useState(true);
  // Bộ lọc khoảng ngày ở trang chủ là luồng riêng của nhà bật isMoney88;
  // nhà không bật giữ nguyên trang chủ đúng như bản chung.
  const [isMoney88, setIsMoney88] = useState(false);

  // const today = () => {
  //   return "27/08";
  // };
  const fetchData = useCallback((khoang) => {
    setLoading(true);
    // Không truyền khoảng ngày -> API trả toàn bộ (trang chủ như ban đầu).
    // Gửi ISO yyyy-MM-dd: Web API bind query-string theo InvariantCulture (MM/dd/yyyy),
    // dd/MM/yyyy sẽ bị hiểu sai ngày/tháng hoặc parse lỗi -> null -> rơi về khoảng mặc định.
    HomeApi.getAll(
      khoang ? format(khoang.dtFrom, "yyyy-MM-dd") : null,
      khoang ? format(khoang.dtTo, "yyyy-MM-dd") : null,
    )
      .then((response) => {
        setInfo({
          ...initData,
          TongGiaoDichTrongNgay: response.data.tongGiaoDichTrongNgay,
          HdTrongNgay: response.data.hdTrongNgay,
          TongChovayTrongNgay: response.data.tongChovayTrongNgay,
          HdTHhuHomNay: response.data.hdTHhuHomNay,
          TienThuHomNay: response.data.tienThuHomNay,
          HdDuKienThu: response.data.hdDuKienThu,
          TienDuKienThu: response.data.tienDuKienThu,
          QuyTien: response.data.QuyTien,
          TongHDDangVay: response.data.tongHDDangVay,
          TongSoCamDo: response.data.tongSoCamDo,
          TongSoTinChap: response.data.tongSoTinChap,
          TongSoTraGop: response.data.tongSoTraGop,
          TongTienChoVay: response.data.tongTienChoVay,
          TongTienCamDo: response.data.tongTienCamDo,
          TongTienTinChap: response.data.tongTienTinChap,
          TongTienVayHo: response.data.tongTienVayHo,
          TongLaiDaThu: response.data.tongLaiDaThu,
          TongCamDoLaiDaThu: response.data.tongCamDoLaiDaThu,
          TongTinChapLaiDaThu: response.data.tongTinChapLaiDaThu,
          TongLaiHoLaiDaThu: response.data.tongLaiHoLaiDaThu,
          TongLaiDuKien: response.data.tongLaiDuKien,
          TongSoChoDuyet: response.data.tongSoChoDuyet,
          tongCamDoLaiTrongThang: response.data.tongCamDoLaiTrongThang,
          tongTinChapLaiTrongThang: response.data.tongTinChapLaiTrongThang,
          tongLaiHoLaiTrongThang: response.data.tongLaiHoLaiTrongThang,
          TongLaiBHTraGopTrongThang: response.data.tongLaiBHTraGopTrongThang,
          TongTienBHTraGop: response.data.tongTienBHTraGop,
          TongLaiBHTraGopDaThu: response.data.tongLaiBHTraGopDaThu,
          TongSoBHTraGop: response.data.tongSoBHTraGop,
        });
      })
      .catch((err) => {
        console.error(err);
        pushNotification("Tải dữ liệu trang chủ thất bại!", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    document.title = "Trang chủ | Phần mềm quản lý cầm đồ Morman";
    kiemTraQuyenTruyCap();
    phanQuyenTrangChu();
    ConfigSystemApi.GetConfigSystemByKeyConfig({ key: cauHinh.sKey.IsMoney88 })
      .then((response) => {
        const value = response.data;
        setIsMoney88(
          value === true ||
            value === 1 ||
            value === "1" ||
            value === "True" ||
            value === "true",
        );
      })
      .catch(() => setIsMoney88(false));
    fetchData(filters);
  }, []);

  const handleApplyFilter = (khoang) => {
    setFilters(khoang);
    fetchData(khoang);
  };

  const nhanKhoang = filters
    ? `${format(filters.dtFrom, "dd/MM")} - ${format(filters.dtTo, "dd/MM")}`
    : "Tất cả";
  const nhanKhoangDayDu = filters
    ? `${format(filters.dtFrom, "dd/MM/yyyy")} - ${format(
        filters.dtTo,
        "dd/MM/yyyy",
      )}`
    : "Tất cả";
  const nhanDenNgay = format(filters ? filters.dtTo : new Date(), "dd/MM/yyyy");
  // Chưa lọc thì "Lãi trong kỳ" mặc định là lãi tháng hiện tại
  const nhanKhoangLaiTrongKy = filters
    ? nhanKhoangDayDu
    : `${format(startOfMonth(new Date()), "dd/MM/yyyy")} - ${format(
        new Date(),
        "dd/MM/yyyy",
      )}`;

  // Bảng thống kê: nhà không bật isMoney88 dùng đúng bản cũ của master.
  const BangThongKe = isMoney88 ? TableThongKeMoney88 : TableThongKe;

  // Chặn theo mã menu "trangchu" để khớp với việc menu đã ẩn mục Trang chủ.
  // Đọc quyền lỗi thì không chặn, tránh đẩy nhầm người dùng ra trang báo lỗi.
  const kiemTraQuyenTruyCap = () => {
    UserApi.getAllQuyen().then((response) => {
      if (response.status !== 200 || !Array.isArray(response.data)) return;
      const coQuyen = response.data.some(
        (e) => (e.ModuleCode || "").toLowerCase() === "trangchu",
      );
      if (!coQuyen) window.location.href = configs.errorLink;
    });
  };

  const phanQuyenTrangChu = () => {
    HomeApi.phanquyen().then((response) => {
      if (response.status == "200") {
        setPhanQuyen({
          ...phanQuyen,
          trangchu_thongtintrangchu: response.data.trangchu_thongtintrangchu,
          trangchu_thongtinhopdong: response.data.trangchu_thongtinhopdong,
          isBanHangTraGop: response.data.isBanHangTraGop,
        });
      }
    });
  };

  return (
    <LayoutV2>
      <div id="form-repeater">
        <div className="col-12">
          <div className="media-home align-center-home">
            <div class="row header">
              <h1 className="text-info-home">Bảng thông tin</h1>
            </div>
          </div>
          {isMoney88 && (
            <div className="card border-light mb-1 card-v2">
              <div className="card-body card-body-v2">
                <SearchBarTrangChu
                  onApply={handleApplyFilter}
                  loading={loading}
                />
              </div>
            </div>
          )}
          <div className="row top-mar-home">
            <div className="col-xl-3 col-lg-12 mb-1">
              <div
                className="card left-top-home"
                style={{ padding: "10px", borderRadius: "10px" }}
              >
                <div className="card-content">
                  <div className="card-v2">
                    <div className="card-body card-body-v2">
                      <div className="row" style={{ alignItems: "center" }}>
                        <div className="col-8 color7">
                          <h1 className="color7-bold">Giao dịch</h1>
                          {isMoney88 ? (
                            <p title={nhanKhoangDayDu}>{nhanKhoang}</p>
                          ) : (
                            <p>
                              Hôm nay{" "}
                              {new Date().getDate() +
                                "/" +
                                (new Date().getMonth() + 1)}
                            </p>
                          )}
                        </div>
                        <div className="col-4 text-right">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/trang_chu_giao_dich.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="row mb-1">
                        <div className="col-12">
                          <a
                            href="/trang-chu/bao-cao/giao-dich-trong-ngay.aspx"
                            style={{ textDecoration: "none" }}
                          >
                            <p className="trangchu-card-info btn-link-trang-chu">
                              {thongtinHome?.TongGiaoDichTrongNgay || 0}
                            </p>
                          </a>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <span className="color-xanh">0%</span>
                          <span className="color7">
                            &nbsp; So với ngày hôm qua
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-12 mb-1">
              <div
                className="card left-top-home"
                style={{ padding: "10px", borderRadius: "10px" }}
              >
                <div className="card-content">
                  <div className="card-v2">
                    <div className="card-body card-body-v2">
                      <div className="row" style={{ alignItems: "center" }}>
                        <div className="col-8 color7">
                          <h1 className="color7-bold">Cho vay</h1>
                          <p>Hợp đồng</p>
                        </div>
                        <div className="col-4 text-right">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/trang_chu_chu_vay.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="row mb-1">
                        <div className="col-12">
                          <p className="trangchu-card-info">
                            {thongtinHome.HdTrongNgay ?? 0}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          ({" "}
                          <span className="color-xanh">
                            {" "}
                            {formatNumber(thongtinHome.TongChovayTrongNgay)}
                          </span>
                          <span className="color7">&nbsp; vnđ</span>)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-12 mb-1">
              <div
                className="card left-top-home"
                style={{ padding: "10px", borderRadius: "10px" }}
              >
                <div className="card-content">
                  <div className="card-v2">
                    <div className="card-body card-body-v2">
                      <div className="row" style={{ alignItems: "center" }}>
                        <div className="col-8 color7">
                          <h1 className="color7-bold">Đã thu</h1>
                          <p>Hợp đồng</p>
                        </div>
                        <div className="col-4 text-right">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/trang_chu_da_thu.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="row mb-1">
                        <div className="col-12">
                          <p className="trangchu-card-info">
                            {thongtinHome.HdTHhuHomNay ?? 0}{" "}
                            <span>
                              &nbsp;| ({" "}
                              {formatNumber(thongtinHome.TienThuHomNay)})
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          Dự thu:
                          <span className="color-xanh">
                            {" "}
                            {thongtinHome.HdDuKienThu}
                          </span>
                          <span className="color7">
                            &nbsp; HĐ| (
                            {formatNumber(thongtinHome.TienDuKienThu)})
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-12 mb-1">
              <div
                className="card left-top-home"
                style={{
                  padding: "10px",
                  borderRadius: "10px",
                  background: "#056569",
                }}
              >
                <div className="card-content">
                  <div className="card-v2 ">
                    <div className="card-body card-body-v2">
                      <div className="row" style={{ alignItems: "center" }}>
                        <div className="col-8 color-white">
                          <h1 className="color-white-bold">Quỹ tiền</h1>
                          <p>&nbsp;</p>
                        </div>
                        <div className="col-4 text-right">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/trang_chu_quy_con_lai.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="row mb-1">
                        <div className="col-12">
                          <a
                            href="/trang-chu/bao-cao/dong-tien.aspx"
                            style={{ textDecoration: "none" }}
                          >
                            <p
                              className="trangchu-card-info btn-link-trang-chu"
                              style={{
                                color: "#00ffd9",
                                fontSize: "2rem",
                                marginTop: "0.7rem",
                              }}
                              title={formatNumber(thongtinHome.QuyTien)}
                            >
                              {(() => {
                                if (thongtinHome.QuyTien >= 10000000000) {
                                  return `${formatNumber(
                                    (thongtinHome.QuyTien / 1000).toFixed(0),
                                  )}K`;
                                }
                                return formatNumber(thongtinHome.QuyTien);
                              })()}
                            </p>
                          </a>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <span className="color-xanh"> &nbsp;</span>
                          <span className="color7">&nbsp;</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 col-lg-12 mb-1">
              <div
                className="card left-top-home"
                style={{ padding: "10px", borderRadius: "10px" }}
              >
                <div className="card">
                  <div className="card-content">
                    <div className="card-body">
                      <BangThongKe
                        tongSoCamDo={thongtinHome.TongSoCamDo}
                        tongSoTinChap={thongtinHome.TongSoTinChap}
                        tongSoTraGop={thongtinHome.TongSoTraGop}
                        tongTienCamDo={thongtinHome.TongTienCamDo}
                        tongTienTinChap={thongtinHome.TongTienTinChap}
                        tongTienVayHo={thongtinHome.TongTienVayHo}
                        tongCamDoLaiDaThu={thongtinHome.TongCamDoLaiDaThu}
                        tongTinChapLaiDaThu={thongtinHome.TongTinChapLaiDaThu}
                        tongLaiHoLaiDaThu={thongtinHome.TongLaiHoLaiDaThu}
                        tongCamDoLaiTrongThang={
                          thongtinHome.tongCamDoLaiTrongThang
                        }
                        tongTinChapLaiTrongThang={
                          thongtinHome.tongTinChapLaiTrongThang
                        }
                        tongLaiHoLaiTrongThang={
                          thongtinHome.tongLaiHoLaiTrongThang
                        }
                        TongLaiBHTraGopTrongThang={
                          thongtinHome.TongLaiBHTraGopTrongThang
                        }
                        TongTienBHTraGop={thongtinHome.TongTienBHTraGop}
                        TongLaiBHTraGopDaThu={thongtinHome.TongLaiBHTraGopDaThu}
                        TongSoBHTraGop={thongtinHome.TongSoBHTraGop}
                        isBanHangTraGop={phanQuyen.isBanHangTraGop}
                        nhanKhoang={nhanKhoangDayDu}
                        nhanDenNgay={nhanDenNgay}
                        nhanKhoangLaiTrongKy={nhanKhoangLaiTrongKy}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row top-mar-home">
            <div className="col-xl-4 col-lg-12 mb-1">
              <div
                className="card left-top-home"
                style={{ padding: "10px", borderRadius: "10px" }}
              >
                <div className="card-content">
                  <div className="card-v2">
                    <div className="card-body card-body-v2">
                      <div className="col-md-12 border-right-new">
                        <h6 className="text-chart text-left  color7-bold">
                          Lãi thu dự kiến
                        </h6>
                        {isMoney88 && (
                          <small className="color7 d-block text-left mb-1">
                            Chốt đến {nhanDenNgay}
                          </small>
                        )}
                        <div id="chartContainer1" className="chart-home1">
                          <CanvasJSChart
                            options={{
                              height: 200,
                              exportEnabled: false,
                              animationEnabled: false,
                              title: {
                                text: "",
                              },
                              legend: {
                                fontSize: 15,
                                fontweight: "normal",
                                horizontalAlign: "right",
                                verticalAlign: "center",
                              },
                              data: [
                                {
                                  type: "pie",
                                  indexLabel: "#percent%",
                                  percentFormatString: "#0.##",
                                  toolTipContent:
                                    "<b>{label}</b>:{y} (#percent%)",
                                  showInLegend: "true",
                                  legendText: "{label}",
                                  indexLabelFontSize: 16,
                                  dataPoints: [
                                    {
                                      y: thongtinHome.TongLaiDaThu,
                                      label: "Đã thu",
                                      color: "#056569",
                                    },
                                    {
                                      y: thongtinHome.TongLaiDuKien,
                                      label: "Chưa thu",
                                      color: "#DB5B00",
                                    },
                                  ],
                                },
                              ],
                            }}
                            /* onRef={ref => this.chart = ref} */
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-12 mb-1">
              <div
                className="card left-top-home"
                style={{ padding: "10px", borderRadius: "10px" }}
              >
                <div className="card-content">
                  <div className="card-v2">
                    <div className="card-body card-body-v2">
                      <div className="col-md-12">
                        <h6 className="text-chart text-left  color7-bold">
                          Tỷ lệ lợi nhuận
                        </h6>
                        {isMoney88 && (
                          <small className="color7 d-block text-left mb-1">
                            Lũy kế đến {nhanDenNgay}
                          </small>
                        )}
                        <div id="chartContainer2" className="chart-home2">
                          <CanvasJSChart
                            options={{
                              height: 200,
                              exportEnabled: false,
                              animationEnabled: false,
                              title: {
                                text: "",
                              },
                              legend: {
                                fontSize: 15,
                                fontweight: "normal",
                                horizontalAlign: "right",
                                verticalAlign: "center",
                              },
                              data: [
                                {
                                  type: "pie",
                                  indexLabel: "#percent%",
                                  percentFormatString: "#0.##",
                                  toolTipContent:
                                    "<b>{label}</b>:{y} (#percent%)",
                                  showInLegend: "true",
                                  legendText: "{label}",
                                  indexLabelFontSize: 16,
                                  dataPoints: [
                                    {
                                      y: thongtinHome.TongCamDoLaiDaThu,
                                      label: "Cầm đồ",
                                      color: "#056569",
                                    },
                                    {
                                      y: thongtinHome.TongTinChapLaiDaThu,
                                      label: "Tín chấp",
                                      color: "#59CB80",
                                    },
                                    {
                                      y: thongtinHome.TongLaiHoLaiDaThu,
                                      label: "Trả góp",
                                      color: "#DB5B00",
                                    },
                                    // Chỉ hiện khi công ty bật bán hàng trả góp, để khớp với cột
                                    // "Tổng lãi đã thu" trong bảng thống kê
                                    ...(isMoney88 && phanQuyen.isBanHangTraGop
                                      ? [
                                          {
                                            y: thongtinHome.TongLaiBHTraGopDaThu,
                                            label: "Bán hàng trả góp",
                                            color: "#F2C94C",
                                          },
                                        ]
                                      : []),
                                  ],
                                },
                              ],
                            }}
                            /* onRef={ref => this.chart = ref} */
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-12 mb-1">
              <div
                className="card left-top-home"
                style={{ padding: "10px", borderRadius: "10px" }}
              >
                <div className="card-content">
                  <div className="card-v2">
                    <div className="card-body card-body-v2">
                      <div className="col-md-12 ">
                        <h6 className="text-chart text-left  color7-bold">
                          Hợp đồng chờ duyệt
                        </h6>
                        <div
                          className="row d-flex justify-content-center"
                          style={{ marginTop: "3rem" }}
                        >
                          <img src="/app-assets/images/icon-hop-dong-cho-duyet.png"></img>
                        </div>
                        <div
                          className="row d-flex justify-content-center"
                          style={{ marginTop: "5.2rem" }}
                        >
                          <h2 className="mb-0 color7-bold">
                            <a href={() => false}>
                              {" "}
                              {formatNumber(thongtinHome.TongSoChoDuyet)}
                            </a>
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutV2>
  );
};
